import React, {Component } from "react";
import {Button, Col, Container, Form, Row, Alert} from "react-bootstrap";
import BuildService from "../services/BuildService";
import {FIRMWARE_TYPE} from "../constants/Constants";
import UpgradeDeviceTable from "../components/UpgradeDeviceTable";
import UpgradeModal from "../components/UpgradeModal";
import { faSearch, faSync } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FactoryResetDeviceModal from "../components/FactoryResetDeviceModal";
import DashboardService from "../services/DashboardService";
import Helper from "../utils/Helper";
import DeviceConfigModal from "../components/DeviceConfigModal";
import RebootAlertModal from "../components/RebootAlertModal";


const strings = require('../resources/strings.json');

export default class DeviceManagement extends Component {

    state = {
        buildList: [],
        buildType: FIRMWARE_TYPE.SWITCH_DEVICE_IMAGE,
        userInfo : "",
        requestMail: "",
        deviceList: [],
        showUpgrade: false,
        switchBuilds: [],
        acBuilds: [],
        selectedDevices: [],
        selectedAc: [],
        userEmail: "",
        selectedPremisesObject: {},
        selectedPremises: "",
        premisesDeviceList: [],
        factoryResetShow: false,
        deviceConfigShow: false,
        configTimestamp: 0,
        configMacId: '',
        rebootDeviceShow: false,
        restartMacId: '',
    }

    constructor(props) {
        super(props);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleFetchClick = this.handleFetchClick.bind(this);
        this.handleUpgrade = this.handleUpgrade.bind(this);
        this.separateBuildBasedOnDeviceType = this.separateBuildBasedOnDeviceType.bind(this);
        this.getDeviceList = this.getDeviceList.bind(this);
        this.getBuildList = this.getBuildList.bind(this);
        this.handleRefresh = this.handleRefresh.bind(this);
        this.onSelectPremise = this.onSelectPremise.bind(this);
        this.selectedPremisesRefresh = this.selectedPremisesRefresh.bind(this);
        this.handleFactoryResetDevice = this.handleFactoryResetDevice.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.activateDevice = this.activateDevice.bind(this);
        this.deactivateDevice = this.deactivateDevice.bind(this);
        this.getErrorMessage = this.getErrorMessage.bind(this);
    }
    

    async componentDidMount() {
        await this.getBuildList();
    }

    async getBuildList () {
        try {
            const builds = await BuildService.getBuilds();
            const buildBasedOnDeviceType = this.separateBuildBasedOnDeviceType(builds)
            this.setState({
                buildList: builds,
                switchBuilds: buildBasedOnDeviceType.dataSwitch,
                acBuilds: buildBasedOnDeviceType.dataAc
            })
        } catch (e) {
            alert("There was an error fetching builds")
        }
    }

    separateBuildBasedOnDeviceType (buildList) {
        let dataSwitch = [], dataAc = [];
        for (let i = 0; i < buildList.length; i++) {
            let buildData = buildList[i];
            let build = {};
            build.id = buildData.id;
            build.buildUrl = buildData.buildUrl;
            build.firmwareType = buildData.firmwareType;
            switch(buildData.firmwareType){
                case FIRMWARE_TYPE.SWITCH_DEVICE_IMAGE: {
                    build.firmwareTypeReadable = strings.switchImage;
                    break;
                }
                case FIRMWARE_TYPE.SWITCH_STM_IMAGE: {
                    build.firmwareTypeReadable = strings.stmImage;
                    break;
                } 
                case FIRMWARE_TYPE.AC_DEVICE_IMAGE: {
                    build.firmwareTypeReadable =  strings.acImage;
                    break;
                }
                default:{
                    build.firmwareTypeReadable =  "";
                }    

            }
            const date = new Date(buildData.addedOn);
            build.addedOn = date.toLocaleString();
            build.version = buildData.major + "." + buildData.minor + "." + buildData.revision;
            if(build.firmwareType === FIRMWARE_TYPE.WIFI_IMAGE)
            {
                dataAc.push(build);
                dataSwitch.push(build)
            }
            else if(build.firmwareType === FIRMWARE_TYPE.AC_DEVICE_IMAGE || build.firmwareType === FIRMWARE_TYPE.PCB_IMAGE) {
                dataAc.push(build);
            } else {
                dataSwitch.push(build);
            } 
        }
        return {dataSwitch, dataAc};
    }

    handleInputChange = (event) => {
        this.setState({ 
            userInfo: event.target.value
        })
    };

    handleFetchClick = async event => {
        this.state.userInfo= this.state.userInfo.trim();
        if (!this.validateInput()) {
            alert(strings.enterValidEmailMac)
            return;
        }
        this.setState({premisesDeviceList: [], selectedPremises: "", selectedPremisesObject: {}, requestMail: this.state.userInfo.trim(), deviceList: [], selectedDevices: [], selectedAc: []});
        await this.getDeviceList(this.state.userInfo.trim()); 
    };


    validateInput = () => {
        return (
            this.state.userInfo && 
            this.state.userInfo != "" &&
            (Helper.validateEmail(this.state.userInfo) ||
            Helper.validateMac(this.state.userInfo))
        )
    }

    async getDeviceList(userInfo) {
        try {
            const response = await BuildService.getDeviceList(userInfo);
            if(response.error){
                throw new Error(response.message);
            }
            this.setState({userEmail: response.email, premisesDeviceList: response.premisesDevicesList, selectedPremises: "", deviceList: [], selectedDevices: [], selectedAc: []})
        } catch (e) {
            alert(e.message);
        }
    }

    handleUpgrade = () => {
        this.setState({ showUpgrade: true})
    }
    
    handleRefresh = async () => {
        this.state.userInfo= this.state.userInfo.trim();
        if (!this.validateInput()) {
            alert(strings.enterValidEmailMac);
            return;
        }
        const premises = this.state.selectedPremises 
        await this.getDeviceList(this.state.userInfo.trim()); 
        if(premises !== "") {
            this.selectedPremisesRefresh(premises);
        }
    }

    //TODO: This will only work if premises name are unique
    selectedPremisesRefresh = (premisesName) => {
        for(const premises of this.state.premisesDeviceList)  {
            if(premisesName === premises.name) {
                this.setState({
                    selectedPremises: premises.name,
                    deviceList: premises.deviceList,
                    selectedDevices: [], 
                    selectedAc: []
                })
            }
        }
    }

    showUpgradeModal = () => {
        this.setState({ showUpgrade: true });
    }

    closeUpgradedModal = () => {
        this.setState({ showUpgrade: false,  });
    }

    handleClose() {
        this.setState({factoryResetShow: false, rebootDeviceShow: false});
    }

    handleConfigClose() {
        this.setState({deviceConfigShow: false});
    }

    handleFactoryResetDevice = function (event) {
        this.setState({factoryResetShow: true});
    };

    restartSwitch(){
        this.handleClose();
        DashboardService.restartDevice(this.state.restartMacId);    
    }
  
    activateDevice = async (mac) => {
      alert("Activate device "+mac);
      try {
          await DashboardService.activateDevice(mac);
      } catch(e) {
          alert(this.getErrorMessage(e));
      } finally {
          this.setState({mac: ""})
      }
      await this.handleRefresh();
  }

  
  deactivateDevice = async (mac) => {
      alert("De-activate device "+mac);
      try {
          await DashboardService.deactivateDevice(mac);
      } catch(e) {
          alert(this.getErrorMessage(e));
      } finally {
          this.setState({mac: ""})
      }
      await this.handleRefresh();
  }

  onSelectPremise = function (event) {
        for(const premises of this.state.premisesDeviceList)  {
            if(premises.id == parseInt(event.target.value)) {
                this.setState({
                    selectedPremisesObject: premises,
                    selectedPremises: premises.name,
                    deviceList: premises.deviceList,
                    selectedDevices: [], 
                    selectedAc: []
                })
            }
        }
    }

    getErrorMessage(e) {
        console.log(JSON.stringify(e))
        if(e.response.data && e.response.data.status == 500 || e.response.data.message == undefined) {
            return strings.errorActivatingDevice;
        }

        return e.response.data.message
    }

    render() { 
        return (
            <Container>
                {this.renderButton()}
                { this.renderDeviceManagementView() }
            </Container>
        );
    }

    renderButton() {
            return (
                <Col sm={5}>
                        <Button variant="danger" style={{marginLeft: 852}} onClick={this.handleFactoryResetDevice}>Factory Reset Device</Button>
                </Col>
            )
    }

    renderDeviceManagementView() {
       
        return (
          <div>
            <Row style={{ marginTop: 30 }}>
              <Form>
                <Form.Group controlId="exampleForm.ControlInput1">
                  <Col sm={4}>
                    <Form.Control
                      required
                      type="text"
                      placeholder="name@example.com"
                      onChange={this.handleInputChange}
                    />
                  </Col>
                  <Col sm={2}>
                    <Button variant="primary" onClick={this.handleFetchClick}>
                      <FontAwesomeIcon icon={faSearch} />
                    </Button>
                  </Col>
                </Form.Group>
              </Form>
              <Col sm={3}>
                <select
                  className="form-control"
                  value={this.state.value}
                  onChange={this.onSelectPremise}
                >
                  <option>Select Premise</option>
                  {this.state.premisesDeviceList.map((e, key) => {
                    if (e.name == this.state.selectedPremises) {
                      return (
                        <option selected key={key} value={e.id}>
                          {e.name}
                        </option>
                      );
                    }
                    return (
                      <option key={key} value={e.id}>
                        {e.name}
                      </option>
                    );
                  })}
                </select>
              </Col>
              <Col sm={1}>
                <Button variant="primary" onClick={this.handleUpgrade}>
                  {strings.upgrade}
                </Button>
              </Col>
              <Col sm={1}>
                <Button variant="primary" onClick={this.handleRefresh}>
                  <FontAwesomeIcon icon={faSync} />
                </Button>
              </Col>
            </Row>
            <Row style={{ marginTop: 50 }}>
              <Col sm={3}> User : {this.state.userEmail} </Col>
              <Col sm={3}> Premises : {this.state.selectedPremises} </Col>
            </Row>
            <Row style={{ marginTop: 30 }}>
              <UpgradeDeviceTable
                deviceList={this.state.deviceList}
                onSelection={(selectedSwitch, selectedAcItems) => {
                  this.setState({
                    selectedDevices: selectedSwitch,
                    selectedAc: selectedAcItems,
                  });
                }}
                activateDevice={this.activateDevice}
                deactivateDevice={this.deactivateDevice}
                onConfigClicked={(macId, deviceConfigShow) => {
                  if (deviceConfigShow === false) {
                    alert("This feature is not available with this device.");
                  } else {
                    this.setState({
                      deviceConfigShow: true,
                      configTimestamp: new Date().getTime(),
                      configMacId: macId,
                    });
                  }
                }}
                onRebootClicked = {(macId)=>{
                    this.setState({rebootDeviceShow: true, restartMacId: macId})
                }}
              />
            </Row>
            <RebootAlertModal
                show ={this.state.rebootDeviceShow}
                onCloseClicked={() => this.handleClose()}
                onRestartSwitch={()=> this.restartSwitch()}
            />
 
            <UpgradeModal
              show={this.state.showUpgrade}
              onCloseClicked={() => this.closeUpgradedModal()}
              buildOptions={this.state.switchBuilds}
              selectedDevices={this.state.selectedDevices}
              selectedAc={this.state.selectedAc}
              buildAcOptions={this.state.acBuilds}
            />
           
            <FactoryResetDeviceModal
              show={this.state.factoryResetShow}
              onCloseClicked={() => this.handleClose()}
              onUpdate={() => this.handleRefresh()}
            />
            <DeviceConfigModal
              deviceConfigShow={this.state.deviceConfigShow}
              configtimestamp={this.state.configTimestamp}
              configUserId={this.state.requestMail}
              configPremiseName={"-"}
              configMacId={this.state.configMacId}
              configdeviceName={"-"}
              configdevicAreaName={"-"}
              onCloseClicked={() => this.handleConfigClose()}
              premises={this.state.selectedPremisesObject}
            />
          </div>
        );
    }
}